import {Component, Input, OnInit} from '@angular/core';
import {LineInterface} from '../../../../lines/models/line.interface';
import {SaveMission} from '../../../store/actions/mission.actions';
import {UpdateSelectedProcedure} from '../../../store/actions/selected-procedure.actions';
import {select, Store} from '@ngrx/store';
import {CustomerInterface} from '../../../../account/models/customer.interface';
import {CustomerStorageService} from '../../../../account/services/customer-storage.service';
import moment from 'moment';
import {ConstsHelper} from '../../../../../helpers/consts.helper';
import {MsisdnListInterfaceState} from '../../../../lines/store/state/msisdn-list.state';
import {MsisdnListInterface} from '../../../../lines/models/msisdn-list.interface';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-retraction',
  templateUrl: './retraction.component.html',
  styleUrls: ['./retraction.component.css'],
  standalone: false
})
export class RetractionComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  retraction: boolean;
  step: number;
  subStep: number;
  isActiveLine: boolean;
  isPortability: boolean;
  billStartDate: number;
  customer: CustomerInterface|null;
  msisdnList: Array<MsisdnListInterface>;
  activeLines: number;
  brand: string;

  constructor(
      private store: Store<any>,
      private customerStorageService: CustomerStorageService,
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.activeLines = 0;
    this.msisdnList = [];
    this.customer = this.customerStorageService.getCustomer();
    this.setStep(1, 'step');
    this.setStep(0, 'subStep');
    this.isActiveLine = ['failed_crea', 'failed_port', 'active'].indexOf(this.line.statusDetails.status.toLowerCase()) !== -1;
    this.billStartDate = moment(this.line.billStartDate).diff(moment(), 'days');
    this.isPortability = this.line.statusDetails.startType.includes('port') || this.line.statusDetails.status.includes('port');
    this.retraction = false;
    this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
      if (response.list instanceof Array && response.list.length > 0) {
        for (const msisdn of response.list) {
          if (msisdn.status.toLowerCase() === 'active' && msisdn.phoneNumber !== this.line.phoneNumber) {
            this.activeLines++;
          }
        }
      }
    });
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  /**
   * Confirmation of the execution of the procedure.
   * Calls procedure.
   */
  confirmation() {
    this.store.dispatch(new SaveMission({ phoneNumber: this.line.phoneNumber }, this.procedureCode));
  }

  setStep(step: number, type: string) {
    if (type === 'step') {
      this.step = step;
    } else {
      this.subStep = step;
    }
  }

  formatDate(portDate: string) {
    return portDate.replace('00:00:00', '');
  }
}
